import {Authority} from "root/Common/Constants/PassportAuthorityTypes.mjs";
import {constructNodePdfUrl, NCL_PDFS} from "root/DataFunctions/PdfDataFns";
import {ProviderVariantType} from "root/Common/Constants/ProviderVariantType";

const v1_header_northumberland = {
    path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
    height: '80px',
    width: '160px',
    title: 'School Readiness Passport',
    subtitle: 'Northumberland Early Years',
}

const v1_header_northumberland_school = {
    path: '/style/images/seven360/estar/estar_people_logo.png',
    height: '70px',
    width: '140px',
    title: 'EHCP Management System',
    subtitle: 'Northumberland County Council',
}

const v1_header_other = {
    path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
    height: '80px',
    width: '160px',
    title: 'School Readiness Passport',
    subtitle: '',
}

const v1_header_ncl = {
    path: '/style/images/seven360/ncl/passport_logo.png',
    height: '60px',
    width: '180px',
    title: 'School Readiness Passport',
    subtitle: '',
}

const v1_header_ntc = {
    path: '/style/images/seven360/ntc/Digital_FullCol_Hor_white_text.png',
    height: '80px',
    width: '180px',
    title: 'School Readiness Passport',
    subtitle: '',
}

const HeaderLogos = {
    [Authority.NCC] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_northumberland, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_northumberland_school },
    [Authority.GHD] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
    [Authority.SUN] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
    [Authority.DUR] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
    [Authority.STC] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
    [Authority.SUN] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
    [Authority.NCL] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_ncl, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_ncl },
    [Authority.NTC] : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_ntc, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_ntc },
    default : { [ProviderVariantType.PASSPORT_PROVIDERS] : v1_header_other, [ProviderVariantType.EHCP_SCHOOLS] : v1_header_other },
}

export const getheaderDescriptor = ( authority_id, variant_type = ProviderVariantType.PASSPORT_PROVIDERS ) =>
{
    const auth_obj = HeaderLogos[authority_id] === undefined ? HeaderLogos.default : HeaderLogos[authority_id];

    return auth_obj[variant_type] ;
}

const LoginParams = {

    [Authority.NCC] : {
        privacyDoc: '/School_Readiness_Passport_Privacy_Notice_1.0.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncc_logo.png',
        logoWidth: '100%',
    },
    [Authority.NCL] : {
        privacyDoc: '/NCC_Privacy_Statement_v1.2.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncl/logonlogo.svg',
        logoWidth: '349px',
    },
    [Authority.NTC] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ntc/Digital_FullCol_Hor.png',
        logoWidth: '400px',
    },
    [Authority.GHD] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    [Authority.RED] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/red/redcar_doc_logo2.png',
        logoWidth: '350px',
    },
    [Authority.SUN] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/sun/Sunderland_City_Council_logo_2023.svg',
        logoWidth: '200px',
    },
    [Authority.DUR] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    [Authority.STC] : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/stc/logo-colour-portrait.svg',
        logoWidth: '400px',
    },
    default : {
        privacyDoc: '/EY_Privacy_Statement_Common.pdf',
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncc_logo.png',
        logoWidth: '100%',
    },
}

export const getLoginParams = ( authority_id ) =>
{
    return LoginParams[authority_id] === undefined ? LoginParams.default : LoginParams[authority_id];
}

export const headerLogoNorthumberland = {
    path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
    height: '80px',
    width: '160px',
    title: 'School Readiness Passporty',
    subtitle: 'Northumberland Early Years',
}


const getHeaderMenuDescriptors = (data) => {

    return {
        [Authority.NCC] : {
            [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
                    { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
                    { type: 'divider' },
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
            [ProviderVariantType.EHCP_SCHOOLS] : [
                { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                        { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
                        { type: 'divider' },
                        { type: 'item', href: "/login.php?logout", text: 'Logout' },
                    ] },
            ],
        },
        [Authority.GHD] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        [Authority.STC] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        [Authority.SUN] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        [Authority.RED] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Redcar_Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        [Authority.NCL] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        [Authority.NTC] : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
        default : { [ProviderVariantType.PASSPORT_PROVIDERS] : [
            { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
                    { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
                    { type: 'divider' },
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ]},
    }
}
export const getHeaderMenuDescriptor = ( data, variant_type = ProviderVariantType.PASSPORT_PROVIDERS ) =>
{
    return getHeaderMenuDescriptors(data)[data.authority_id][variant_type] === undefined ? getHeaderMenuDescriptors(data)[variant_type].default : getHeaderMenuDescriptors(data)[data.authority_id][variant_type];
}

export const passportNorthumberlandMenu = [
    { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
    { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
            { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
            { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
            { type: 'divider' },
            { type: 'item', href: "/login.php?logout", text: 'Logout' },
        ] },
]
